<template>
  <div class="sys-config-sql-page">
    <el-form :model="queryCondition" :inline="true" label-position="left">
      <el-form-item label="名称">
        <el-input v-model="queryCondition.Title" placeholder="输入名称"></el-input>
      </el-form-item>
      <el-form-item label="代码">
        <el-input v-model="queryCondition.SqlCode" placeholder="输入代码"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-radio-group v-model="queryCondition.Enable">
          <el-radio :label="100">全部</el-radio>
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onBtnSearch">查询</el-button>
        <el-button type="primary" @click="onAddConfigSql">添加</el-button>
      </el-form-item>
    </el-form>

    <div>
      <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :current-page="queryCondition.pageindex" :page-sizes="[15,20,30,50,100]" :page-size="queryCondition.pagesize" layout="total,sizes,prev,pager,next,jumper" :total="queryCondition.count" >
      </el-pagination>
    </div>
    <el-table :data="sqlDatas" border style="width: 100%" v-loading="loading">
      <el-table-column prop="Title" label="名称" width="180"></el-table-column>
      <el-table-column prop="SqlCode" label="代码" width="180"></el-table-column>
      <el-table-column prop="SqlText" label="SQL" show-overflow-tooltip></el-table-column>
      <el-table-column prop="Enable" label="有效" width="150">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Enable==1?'success':'info'">{{scope.row.Enable==1?'启用':'禁用'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="changeEnable(scope.row)" :type="scope.row.Enable==1?'warning':'success'" size="mini">{{scope.row.Enable==1?'禁用':'启用'}}</el-button>
          <el-button @click="onEditConfigSql(scope.row)" type="primary" size="mini">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="添加/修改配置Sql" :visible.sync="dlgAddConfigSql" width="90%">
      <el-form label-width="80px" :model="editConfigSql" :rules="rules" ref="sqlForm">
        <el-form-item label="名称" prop="Title">
          <el-input v-model="editConfigSql.Title" placeholder="输入名称"></el-input>
        </el-form-item>
        <el-form-item label="代码" prop="SqlCode">
          <el-input v-model="editConfigSql.SqlCode" placeholder="输入代码"></el-input>
        </el-form-item>
        <el-form-item label="SQL">
          <el-input type="textarea" v-model="editConfigSql.SqlText" rows="20"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-switch v-model="editConfigSql.Enable" active-value="0" inactive-value="1" active-color="#dcdfe6" inactive-color="#13ce66" active-text="禁用" inactive-text="启用"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dlgAddConfigSql = false" :disabled="loading">取 消</el-button>
        <el-button type="primary" @click="onSaveConfigSql" :disabled="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {searchConfigSql,saveConfigSql} from '../../api/config_sql'

export default {
  data() {
    return {
      queryCondition: {Title:"", SqlCode:"", Enable: 100, pageindex: 1, pagesize: 20, count:0},
      sqlDatas:[],
      dlgAddConfigSql:false,
      editConfigSql: {ID:0, Title:"", SqlCode:"", SqlText:"", Enable: 1},
      loading:false,
      rules:{
        Title:[{ required: true, message: '请输入名称', trigger: 'blur' }],
        SqlCode:[{ required: true, message: '请输入代码', trigger: 'blur' }]
      }
    };
  },
  created(){
    this.onSearch();
  },
  methods:{
    changeEnable:function(cfgSql){
      var saveSql = Object.assign({}, cfgSql, {Enable: cfgSql.Enable == 1?0:1});
      this.loading = true
      saveConfigSql(saveSql).then(resp=>{
        this.loading = false
        if (resp.data.code == 100){
          this.$notify.success({title: '成功',message: '保存成功'})
          cfgSql.Enable = saveSql.Enable;
        }else{
          this.$notify.error({title: '失败',message: resp.data.msg})
        }
      },err=>{
        this.$notify.error({title:'修改失败',message:err.statusText})
        this.loading = false
      });
    },
    onBtnSearch:function(){
      this.queryCondition.pageindex = 1;
      this.onSearch();
    },
    onSearch:function(){
      var that = this;
      this.loading = true
      searchConfigSql(this.queryCondition).then(resp=>{
        that.loading = false
        if (resp.data.code == 100){
          that.sqlDatas = resp.data.data.Data;
          that.queryCondition.count = resp.data.data.Count;
        }else{
          that.$notify.error({title: '失败',message: "加载数据失败：" + resp.data.msg})
        }
      },err=>{
        that.loading = false
        that.$notify.error({title:'查询失败',message:err.statusText})
      });
    },
    onAddConfigSql:function(){
      this.editConfigSql = {ID:0, Title:"", SqlCode:"", SqlText:"", Enable: 1};
      this.dlgAddConfigSql = true;
      if (this.$refs['sqlForm'])this.$refs['sqlForm'].resetFields();
    },
    onEditConfigSql:function(cfgSql){
      this.editConfigSql = Object.assign({}, cfgSql);
      this.editConfigSql.Enable = this.editConfigSql.Enable + '';
      this.dlgAddConfigSql = true;
      if (this.$refs['sqlForm'])this.$refs['sqlForm'].resetFields();
    },
    onSaveConfigSql:function(){
      var isValid = false
      this.$refs['sqlForm'].validate((valid) => {
        isValid = valid
        return valid;
      });
      if(!isValid){
        this.$notify.info({title: '警告',message: "请按要求填写数据"})
        return
      }

      this.dlgAddConfigSql = false;
      this.editConfigSql.Enable = this.editConfigSql.Enable * 1;
      this.loading = true
      saveConfigSql(this.editConfigSql).then(resp=>{
        this.loading = false
        if (resp.data.code == 100){
          this.$notify.success({title: '成功',message: '保存成功'})
          if (this.editConfigSql.ID == 0){
            this.onSearch();
          }else{
            for(var i = 0; i < this.sqlDatas.length; i++){
              if (this.sqlDatas[i].ID == this.editConfigSql.ID){
                this.sqlDatas[i] = Object.assign(this.sqlDatas[i], this.editConfigSql);
                break;
              }
            }
          }
        }else{
          this.$notify.error({title: '失败',message: resp.data.msg})
        }
      },err=>{
        this.$notify.error({title:'保存',message:err.statusText})
        this.loading = false
      });
    },
    onSizeChange(curSize){
      this.queryCondition.pagesize = curSize;
      this.queryCondition.pageindex = 1;
      this.onSearch();
    },
    onCurrentChange(curIndex){
      this.queryCondition.pageindex = curIndex;
      this.onSearch();
    }
  }
}
</script>
